/**
商品列表
**/
<template>
  <div class="right_a_side_content">
    <h3 class="headerTitle">拍卖详情</h3>
    <el-divider></el-divider>
    <el-row :gutter="20"  v-loading='loading'>
      <div class="header-button">
        <div class="info-header">
          <p>{{auctionObj.title}}</p>
        </div>
        <div>
          <el-button size="mini" @click="goToOrderPage()" :disabled="auctionObj.status !== 2 || remainingTime.status !== '进行中' || isOrdering">¥立即下单</el-button>
<!--          <el-button size="mini" @click="">导出商品</el-button>-->
        </div>
      </div>

      <div>
        <el-row class="info-content">
          <el-col :span="24" class="info_detail">
            <span>类型：{{auctionType(auctionObj.type)}}</span>
            <span>参与人数：{{auctionObj.bidderNumber || 0}}</span>
            <span v-if="formatCountdown(auctionObj.startTime, auctionObj.endTime).status === '进行中'">距离结束：{{ remainingTime.countdown }}</span>
            <span v-else>活动状态：{{formatCountdown(auctionObj.startTime, auctionObj.endTime).status}}</span>
          </el-col>
          <el-col :span="24" class="info_detail">
            <span class="auction-item-money">加价幅度：<i>¥{{ (auctionObj.bidIncrement || 0).toFixed(2) }}</i></span>
            <span class="auction-item-money">起拍价：<i>{{ (auctionObj.startingPrice || 0).toFixed(2) }} 元</i></span>
            <span class="auction-item-money">当前价格：<i>{{ (auctionObj.startingPrice || 0).toFixed(2) }} 元</i></span>
          </el-col>
          <el-col :span="24" class="info_detail" v-if="auctionObj.platformRemark !== ''">
            <span style="font-size: 12px">平台备注：{{auctionObj.platformRemark}}</span>
          </el-col>
        </el-row>
      </div>
      <el-table :data="commodityArr"
                border
                style="width: 100%" height="588"
                resizable
                ref="table"
                sum-text="合计"
                :summary-method="getSummaries"
                show-summary
      >
        <el-table-column align="center" prop="skuNo" label="编码" width="140">
          <template slot-scope="scope">
            {{ scope.row.skuNo != null ? scope.row.skuNo : ''}}
          </template>
        </el-table-column>
        <el-table-column align="center" prop="name" label="名称" width="290" >
          <template slot-scope="scope">
            {{scope.row.name}} {{scope.row.skuName	!=null  ?scope.row.skuName	:'默认规格'}}
          </template>
        </el-table-column>
        <el-table-column align="center" width="70" prop="skuLevel" label="等级">
          <template slot-scope="scope">
            {{ levelText(scope.row.skuLevel) }}
          </template>
        </el-table-column>
        <el-table-column align="center" width="110" prop="price" label="单价">
          <template slot-scope="scope">
            {{ (scope.row.price || 0).toFixed(2) }}
          </template>
        </el-table-column>
        <el-table-column align="center" width="60" prop="auctionNum" label="数量"></el-table-column>
        <el-table-column align="center" prop="totalPrice" label="总价">
          <template slot-scope="scope">
            {{ (scope.row.totalPrice || 0).toFixed(2) }}
          </template>
        </el-table-column>
      </el-table>

    </el-row>
  </div>
</template>
<script>
import {getAuctionDetail, onePriceAuctionOrder, getAuctionCommodityPageList} from '@/api/xunyou'
export default {
  data() {
    return {
      loading: false,
      auctionId: '', // 拍卖id
      auctionObj: '', // 拍卖对象
      commodityArr: [], // 商品列表
      interval: null, // 定时器
      commodityAmount: 0, // 商品总价
      commodityNumber: 0, // 商品总数量
      remainingTime: { status: '', countdown: '' }, // 倒计时结果
      userInfo: JSON.parse(localStorage.getItem("userdata")) || {},
      // 分页参数
      pageparm:{
        pageSize:15,
        pageNum:1,
        total:0,
      },
      loadingMore: false, // 是否正在加载更多数据
      isOrdering: false, // 是否正在下单
    };
  },
  created() {
    // 获取查询参数中的 id
    this.auctionId = this.$route.query.auctionId;
    this.getAuctionDetail();
  },
  mounted() {
    this.interval = setInterval(() => {
      this.updateRemainingTime();
    }, 1000);

    // 监听滚动事件
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    clearInterval(this.interval);
    // 移除滚动事件监听
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    getAuctionDetail() {
      this.loading = true
      getAuctionDetail({id:this.auctionId}).then(res => {
        if(res.code === 0){
          this.loading = false
          this.auctionObj = res.data
          this.getAuctionCommodityPageList(this.auctionObj.id)
          this.commodityAmount = res.data.auctionCommodityAmount
          this.commodityNumber = res.data.auctionCommodityNumber

        } else if(1 === parseInt(res.code)) {
          this.$router.push({path:'/login'})
        } else {
          this.$message.error(res.msg);
        }
      })
        .catch(err => {
          console.log('getAuctionDetail fail', err)
          this.loading = false
          this.$message.error('查询拍卖活动失败，请稍后再试！')
        })
    },
    //拍卖商品分页列表
    getAuctionCommodityPageList(auctionId){
      this.pageparm.auctionId = auctionId
      getAuctionCommodityPageList(this.pageparm)
        .then(res => {
          if (res.code === 0) {
            this.commodityArr = res.rows
            this.pageparm.total = res.total;
            this.$nextTick(() => {
              console.log('表格重新渲染了');
              this.$refs['table'].doLayout();
            })
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch(err => {
          console.log('getAuctionCommodityPageList fail', err)
          this.$message.error('查询拍卖商品失败，请稍后再试！')
        })
    },
    loadMore() {
      if (this.loadingMore || this.commodityArr.length >= this.pageparm.total) return;
      this.loadingMore = true;
      this.pageparm.pageNum += 1;
      getAuctionCommodityPageList({
        auctionId: this.auctionId,
        page: this.pageparm.pageNum,
        size: this.pageparm.pageSize
      }).then(res => {
        if (res.code === 0) {
          this.loadingMore = false;
          this.commodityArr = this.commodityArr.concat(res.rows);
        } else {
          this.$message.error(res.msg);
        }
      }).catch(err => {
        console.log('loadMore fail', err);
        this.loadingMore = false;
        this.$message.error('加载更多数据失败，请稍后再试！');
      });
    },
    handleScroll() {
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      const windowHeight = document.documentElement.clientHeight;
      const scrollHeight = document.documentElement.scrollHeight;

      if (scrollTop + windowHeight >= scrollHeight - 100 && !this.loadingMore) {
        this.loadMore();
      }
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          // 只计算特定字段的合计
          if (column.property === 'auctionNum') {
            sums[index] = this.commodityNumber;
          } else if (column.property === 'totalPrice') {
            sums[index] = `${this.commodityAmount.toFixed(2)} `;
          } else {
            sums[index] = '';
          }
        } else {
          sums[index] = '';
        }
      });
      console.log('合计行数据', sums)
      return sums;
    },
    // 拍下
    goToOrderPage(){
      this.isOrdering = true;
      onePriceAuctionOrder({
        auctionId:this.auctionId,
        uid: this.userInfo.userId,
        price: 0
      }).then(res => {
        console.log(res)
        if(res.code === 0){
          this.$message.success("下单成功")
          setTimeout(() => {
            this.$router.push({path:'/auctionOrderDetail',query:{oid:res.data.oid}})
          }, 800)

        } else {
          this.$message({
            type: 'info',
            message: res.msg
          })
        }
      })
      .catch(err => {
        console.log('getAuctionDetail fail', err)
        this.loading = false
        this.$message.error('拍下失败，请稍后再试！')
      })
      .finally(() => {
        this.isOrdering = false; // 设置标志位为 false
      });
    },
    //   类型转换
    auctionType(type){
      switch(type) {
        case 1:
          return '明拍'
          break;
        case 2:
          return '暗拍'
          break;
        case 3:
          return '一口价'
          break
        default:
          return '--'
      }
    },
    formatCountdown(startTime, endTime) {
      const now = new Date();
      const start = new Date(startTime);
      const end = new Date(endTime);
      const diff = end.getTime() - now.getTime();

      if (now.getTime() - start.getTime() < 0) {
        return { status: '未开始', countdown: '' };
      }
      if (diff <= 0) {
        return { status: '已结束', countdown: '' };
      }

      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);

      const countdown = days > 0 ? `${days}天 ${hours}小时 ${minutes}分钟 ${seconds}秒` : `${hours}小时 ${minutes}分钟 ${seconds}秒`;

      return { status: '进行中', countdown };
    },
    updateRemainingTime() {
      if (this.auctionObj.startTime && this.auctionObj.endTime) {
        this.remainingTime = this.formatCountdown(this.auctionObj.startTime, this.auctionObj.endTime);
      }
    },

    //   B=零售,C=分销,D=拍卖,Z=待整理
    levelText(level){
      switch(level) {
        case 'B':
          return '零售'
          break;
        case 'C':
          return '分销'
          break;
        case 'D':
          return '拍卖'
          break;
        case 'Z':
          return '待整理'
          break;
        default:
          return '--'
      }
    },
  },
};
</script>

<style scoped lang="less">
.right_a_side_content {

  .headerTitle {
    font-size: 20px;
    height: 40px;
    line-height: 40px;
    color: #666;
  }
  i.pointNum {
    font-size: 42px;
    font-weight: 600;
  }
  .info-header {
    padding-left: 20px;
    box-sizing: border-box;
    p {
      font-size: 18px;
      color: #78b942;
      margin-bottom: 5px;
    }
  }
  .header-button {
    display: flex;
    justify-content: space-between;
    button.el-button.el-button--default.el-button--mini {
      background: #f896521a;
      color: #78b942;
      border: 1px solid #78b942;
    }
    .el-button.el-button--mini:focus, .el-button.el-button--mini:hover {
      background: #78b942 !important;
      color: white !important;
    }
  }
  .info-content {
    padding: 20px;
    box-sizing: border-box;
    .info_detail {
      color: #757575;
      font-size: 13px;
      margin-bottom: 4px;
      span{
        margin-right: 40px;
      }
      .auction-item-money i{
        font-size: 20px;
        color: #78b942;
      }
    }
  }
  .loading-more {
    text-align: center;
    padding: 10px 0;
    color: #78b942;
  }

}
</style>







// WEBPACK FOOTER //
// src/views/auction/auctionDetail.vue